import {OrderByDirection} from '@coolcolduk/firebase-util';
import {mapTradeTagDbToType, TradeTag, TradeTagDb} from '@cp/model';
import {QuerySnapshot} from 'firebase/firestore';
import buildFirestoreQuery from '../../helper/firebase/buildFirestoreQuery';
import mapFirestoreDocs from '../../helper/firebase/mapFirestoreDocs';
import {FirestoreCursor} from '../../types/FirestoreCursor';
import {getTradeTagsCollection} from './getTradeTagsCollection';

export const TRADE_TAGS_PAGE_SIZE = 100;

export function listTradeTagsQuery(
  uid: string,
  limit?: number,
  cursor?: FirestoreCursor,
): Promise<QuerySnapshot<TradeTag, TradeTagDb>> {
  return buildFirestoreQuery(getTradeTagsCollection(uid), {
    order: {field: 'label', direction: OrderByDirection.ASC},
    ...(cursor ? cursor : {}),
    ...(limit ? {limit} : {}),
  });
}

export default async function listTradeTags(uid: string, limit: number, cursor?: FirestoreCursor): Promise<TradeTag[]> {
  const snapshot = await listTradeTagsQuery(uid, limit, cursor);
  return mapFirestoreDocs(snapshot.docs, mapTradeTagDbToType);
}
